import { NavLink, useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Users, FileText, BrainCircuit, Briefcase, Settings, LogOut, Menu, X, GitCompare, Mail } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/candidates", label: "Candidates", icon: Users },
  { to: "/admin/applications", label: "Applications", icon: FileText },
  { to: "/admin/analysis", label: "Analysis", icon: BrainCircuit },
  { to: "/admin/compare", label: "Compare", icon: GitCompare },
  { to: "/admin/jobs", label: "Jobs", icon: Briefcase },
  { to: "/admin/emails", label: "Emails", icon: Mail },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout({ title, children, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const Sidebar = (
    <aside className="w-60 shrink-0 bg-[#101820] text-[#E4C675] flex flex-col h-full border-r border-[#C79A3B]/20">
      <Link to="/admin" className="flex items-center gap-2 px-4 h-16 border-b border-[#C79A3B]/15">
        <img src="/kera-logo.webp" alt="KERA" className="h-8 w-auto" />
        <span className="text-[#C79A3B] text-[9px] tracking-[0.2em] uppercase">Recruitment</span>
      </Link>
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-sidebar-${n.label.toLowerCase()}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all ${
              isActive ? "bg-[#C79A3B]/15 text-[#FAF6EE] border-l-2 border-[#C79A3B]" : "text-[#E4C675]/70 hover:text-[#FAF6EE] hover:bg-white/5"}`}>
            <n.icon className="h-4 w-4" /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="px-3 py-4 border-t border-[#C79A3B]/15">
        <div className="px-3 mb-2 text-xs text-[#E4C675]/60 truncate">{user?.email}<div className="uppercase tracking-wider text-[10px] text-[#C79A3B]">{(user?.admin_role || "").replace("_", " ")}</div></div>
        <button data-testid="admin-logout-button" onClick={() => { logout(); navigate("/admin/login"); }} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-[#E4C675]/70 hover:text-[#FAF6EE] hover:bg-white/5 w-full">
          <LogOut className="h-4 w-4" /> Log out
        </button>
      </div>
    </aside>
  );

  return (
    <div className="flex h-screen bg-[#FAF6EE] overflow-hidden">
      <div className="hidden lg:block h-full">{Sidebar}</div>
      {open && <div className="lg:hidden fixed inset-0 z-50 flex"><div className="h-full">{Sidebar}</div><div className="flex-1 bg-black/50" onClick={() => setOpen(false)} /></div>}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-16 bg-[#101820] text-[#FAF6EE] border-b border-[#C79A3B]/30 flex items-center justify-between px-4 lg:px-8">
          <div className="flex items-center gap-3">
            <button className="lg:hidden" onClick={() => setOpen(true)}><Menu /></button>
            <h1 className="font-heading font-bold text-lg">{title}</h1>
          </div>
          <div className="flex items-center gap-3">{actions}</div>
        </header>
        <main className="flex-1 overflow-y-auto p-4 md:p-8 space-y-6 scrollbar-thin">{children}</main>
      </div>
    </div>
  );
}

export function scoreColor(score) {
  if (score >= 80) return "bg-[#2E7D32]/10 text-[#2E7D32] border-[#2E7D32]/30";
  if (score >= 65) return "bg-[#C79A3B]/15 text-[#8a6a1e] border-[#C79A3B]/40";
  if (score >= 50) return "bg-[#C79A3B]/10 text-[#a07a26] border-[#C79A3B]/30";
  return "bg-[#C76A32]/10 text-[#C76A32] border-[#C76A32]/30";
}
export function eligBadge(status) {
  if (status === "eligible") return "bg-[#2E7D32]/10 text-[#2E7D32] border border-[#2E7D32]/30";
  if (status === "review") return "bg-[#C79A3B]/15 text-[#8a6a1e] border border-[#C79A3B]/40";
  return "bg-[#C76A32]/10 text-[#C76A32] border border-[#C76A32]/30";
}
